<mat-card class="emp-card" [ngClass]="backgroundclass"><div class="shortdate">{{employee.date | date: 'dd'}} </div><span class="month">{{employee.date | date: 'MMM'}}</span>
  <app-image [imageId]="imageGuid"></app-image>
    <div class="username">
    {{employee.fullName}}
    <div class="empname">{{employee.structureName}}</div>
  </div>

  </mat-card>
